import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchPatientDownload,
  usePatientList,
} from "../../../api/member-management/use-patient";
import Modal from "../../../components/ui/Modal/Modal";
import Table from "../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.name, {
      header: "환자명",
      cell: (info) => {
        const val = info.getValue();
        const name = val?.length > 10 ? val?.substring(0, 10) + "..." : val;

        return <div className="w-32 mx-auto">{val ? name : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.citizenNo, {
      header: "주민등록번호",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.gender, {
      header: "성별",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? (val === "F" ? "여성" : "남성") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.contact, {
      header: "휴대전화 번호",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.address, {
      header: "주소",
      cell: (info) => {
        const val = info.getValue();
        const address = val?.length > 35 ? val?.substring(0, 35) + "..." : val;

        return (
          <div className="w-48 text-center mx-auto">{val ? address : "-"}</div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "가입일시",
      cell: (info) => {
        const val = info.getValue();
        const date = dayjs(val).format("YYYY-MM-DD HH:mm");
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "관리",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`/patient/${id}`)}
      className="w-12 p-[1px] mx-2 border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function PatientTable(props) {
  const { filter } = props;
  const { isEmpty, getDataTableProps } = usePatientList(filter);
  const [isEmptyResult, setIsEmptyResult] = React.useState(false);
  const [tableData, setTableData] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    getDataTableProps().pagination?.pageIndex + 1
  );
  const [pageSize, setPageSize] = React.useState(
    getDataTableProps().pagination?.pageSize
  );
  const [totalData, setTotalData] = React.useState(
    getDataTableProps().totalAll
  );
  const [pageCount, setPageCount] = React.useState(
    getDataTableProps().pageCount
  );

  const hasSearchKeyword = Boolean(filter?.name || filter?.phone);

  const onSave = async () => {
    await fetchPatientDownload(filter).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `patient-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
    });
  };

  React.useEffect(() => {
    if (isEmpty && hasSearchKeyword) {
      setIsEmptyResult(true);
    } else {
      setIsEmptyResult(false);
    }
  }, [isEmpty, filter, hasSearchKeyword]);

  React.useEffect(() => {
    if (!isEmpty) {
      setTableData(getDataTableProps()?.data);
      setCurrentPage(getDataTableProps()?.pagination?.pageIndex + 1);
      setPageSize(getDataTableProps().pagination?.pageSize);
      setTotalData(getDataTableProps().totalAll || getDataTableProps().total);
      setPageCount(getDataTableProps().pageCount);
    }
  }, [getDataTableProps()]);

  if (isEmpty && !hasSearchKeyword) {
    return (
      <div className="flex justify-center mt-[140px] text-[#999999] text-center text-[14px]">
        등록된 내역이 없습니다.
      </div>
    );
  }

  return (
    <>
      <Table
        {...getDataTableProps()}
        onSave={onSave}
        hasPageSizeFilter={false}
        hasSort={false}
        columns={columns(currentPage, pageSize, totalData)}
        data={tableData}
        pageCount={pageCount}
      />

      {isEmptyResult && (
        <Modal
          isOpenFromOutside={isEmptyResult}
          setIsOpenFromOutside={setIsEmptyResult}
          description="검색결과가 없습니다."
          hasCancel={false}
        />
      )}
    </>
  );
}
